import { parseDate, roundToXDecimals } from '@ais-ui/utils';
import { QueryPointResult } from './extractTargetInfo';

export interface BaseStationTargetInfo {
  country: string;
  flag: string;
  lastAisReport: Date | null;
  lastAisLatitude: string;
  lastAisLongitude: string;
  lastAisSatLatitude: string;
  lastAisSatLongitude: string;
  lastAisSatReport: Date | null;
  latitudeDegrees: string;
  longitudeDegrees: string;
  latitude: number;
  longitude: number;
  mmsi: string;
  targetType: string;
  vdlLoad: string;
}

const desiredTargetNames: string[] = [
  'Last AIS Latitude',
  'Last AIS Longitude',
  'Last AIS-Sat Latitude',
  'Last AIS-Sat Longitude',
  'Latitude',
  'Longitude',
];

const desiredTargetIds: string[] = [
  'country',
  'flag',
  'lastaisreport',
  'lastaissatreport',
  'mmsi',
  'vdlload',
];

export function extractBasestationTargetInfos(
  result: QueryPointResult
): BaseStationTargetInfo[] {
  const baseStationTargetInfos: BaseStationTargetInfo[] = [];
  for (const target of result.targetInfo) {
    const rawBasestationTargetInfo: { [key: string]: string } = {};
    for (const target_value of target.values) {
      // Here we map values by their ID
      if (desiredTargetIds.includes(target_value.id)) {
        rawBasestationTargetInfo[target_value.id] = target_value.value;
      }
      // Some values have the same ID so here we map those by the NAME instead
      if (desiredTargetNames.includes(target_value.name)) {
        rawBasestationTargetInfo[target_value.name] = target_value.value;
      }
    }
    const mmsi = target['mmsi'] || rawBasestationTargetInfo['MMSI'];

    const baseStationInfo: BaseStationTargetInfo = {
      country: rawBasestationTargetInfo['country'],
      flag: rawBasestationTargetInfo['flag'],
      lastAisReport: parseDate(rawBasestationTargetInfo['lastaisreport']),
      lastAisLatitude: rawBasestationTargetInfo['Last AIS Latitude'],
      lastAisLongitude: rawBasestationTargetInfo['Last AIS Longitude'],
      lastAisSatLatitude: rawBasestationTargetInfo['Last AIS-Sat Latitude'],
      lastAisSatLongitude: rawBasestationTargetInfo['Last AIS-Sat Longitude'],
      lastAisSatReport: parseDate(rawBasestationTargetInfo['lastaissatreport']),
      latitudeDegrees: rawBasestationTargetInfo['Latitude'],
      longitudeDegrees: rawBasestationTargetInfo['Longitude'],
      latitude: target['lat']
        ? roundToXDecimals(target['lat'], 4)
        : target['lat'],
      longitude: target['lon']
        ? roundToXDecimals(target['lon'], 4)
        : target['lon'],
      mmsi: mmsi,
      targetType: target['type'],
      vdlLoad: rawBasestationTargetInfo['vdlload'],
    };
    baseStationTargetInfos.push(baseStationInfo);
  }

  return baseStationTargetInfos;
}
